<template>
  <div class="sendDialog column-me">
    <div class="flex1 overflow-auto padding-right10">
      <div class="item-order" v-for="(item,index) in showOrderArray" :key="index">
        <div v-if="source==='normal'">处方{{ index + 1 }}&emsp;处方订单号：{{ item.orderNo }}</div>
        <div v-if="source==='link'">联单{{ index + 1 }}&emsp;联单号：{{ item.jointNo }}</div>

        <div class="row-me row-center margin-top20">
          <div class="left-title font-bold">发货方式：</div>
          <div class="margin-left10">{{ item.deliveryCompany }}</div>
        </div>
        <!--厂内配送-->
        <div v-if="item.deliveryCompany==='厂内配送'||item.deliveryCompany==='自提'">
          <div class="row-me row-center margin-top10">
            <div class="left-title">配送人员：</div>
            <div class="width270 margin-left10">
              <el-input placeholder="请输入" style="width: 100%;" clearable v-model="item.deliveryStaff"></el-input>
            </div>
          </div>
          <div class="row-me row-center margin-top10">
            <div class="left-title">运费金额：</div>
            <div class="width270 margin-left10">
              <el-input placeholder="请输入" style="width: 100%;" clearable v-model="item.freightFee"
                        @input="item.freightFee=this.$method.checkInput(item.freightFee,2)"></el-input>
            </div>
          </div>
        </div>
        <!--快递配送-->
        <div v-else>
          <div class="row-me row-center margin-top20" v-if="!isOpenExpress">
            <div class="left-title">快递单号：</div>
            <div class="width270 margin-left10">
              <el-input placeholder="请输入快递单号" style="width: 100%;" clearable
                        v-model="item.deliveryNo"></el-input>
            </div>
          </div>
          <div class="row-me row-center margin-top10">
            <div class="left-title">寄件类型：</div>
            <div class="width270 margin-left10">
              <el-select placeholder="请选择" style="width: 100%;" filterable clearable
                         v-model="item.sendType">
                <el-option v-for="item in ['标快','特快']" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="row-me row-center margin-top10">
            <div class="left-title">运费方式：</div>
            <div class="width270 margin-left10">
              <el-select placeholder="请选择" style="width: 100%;" filterable clearable
                         v-model="item.deliveryType" @change="e=>deliveryTypeChange(e,item)">
                <el-option v-for="item in deliveryTypeArray" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="row-me row-center margin-top10" v-if="item.deliveryType===2">
            <div class="left-title">月结卡号：</div>
            <div class="width270 margin-left10">
              <el-input placeholder="请输入" style="width: 100%;" clearable v-model="item.monthCard"></el-input>
            </div>
          </div>
          <div class="row-me row-center margin-top10">
            <div class="left-title">是否保价：</div>
            <div class="margin-left10">
              <el-radio-group v-model="item.isInsure">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="row-me row-center margin-top10">
            <div class="left-title">寄件方式：</div>
            <div class="width270 margin-left10">
              <el-select placeholder="请选择" style="width: 100%;" filterable clearable
                         v-model="item.sendMethod" disabled>
                <el-option v-for="item in ['上门取件']" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="row-me row-center margin-top10" v-if="item.deliveryType!==1">
            <div class="left-title">运费金额：</div>
            <div class="width270 margin-left10">
              <el-input placeholder="请输入" style="width: 100%;" clearable v-model="item.freightFee"
                        @input="item.freightFee=this.$method.checkInput(item.freightFee,2)"></el-input>
            </div>
          </div>
        </div>

        <div class="row-me margin-top10">
          <div class="left-title">收件人信息：</div>
          <div class="column-me flex1 margin-left10">
            <div class="row-me row-center">
              <div class="flex1">
                <el-input placeholder="请输入收件人姓名" style="width: 100%;" clearable
                          v-model="item.receiveName"></el-input>
              </div>
              <div class="flex1 margin-left10">
                <el-input placeholder="请输入收件人电话" style="width: 100%;" clearable
                          @input="item.receiveMobile=this.$method.checkInput(item.receiveMobile,0)"
                          v-model="item.receiveMobile"></el-input>
              </div>
              <div class="flex1 margin-left10"></div>
            </div>
            <div class="row-me row-center margin-top10">
              <div class="flex1">
                <el-select v-model="item.receiveProvince" placeholder="请选择省" style="width: 100%;" filterable
                           clearable @change="e=>provinceChange(e,item)">
                  <el-option v-for="item in provinceArray" :key="item.id" :label="item.n"
                             :value="item.n">
                  </el-option>
                </el-select>
              </div>
              <div class="flex1 margin-left10">
                <el-select v-model="item.receiveCity" placeholder="请选择市" style="width: 100%;" filterable
                           clearable @change="e=>cityChange(e,item)">
                  <el-option v-for="item in cityArray" :key="item.id" :label="item.n" :value="item.n">
                  </el-option>
                </el-select>
              </div>
              <div class="flex1 margin-left10">
                <el-select v-model="item.receiveRegion" placeholder="请选择区/县" style="width: 100%;" filterable
                           clearable>
                  <el-option v-for="item in areaArray" :key="item.id" :label="item.n" :value="item.n">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="flex1 margin-top10">
              <el-input placeholder="请输入详细地址" style="width: 100%;" clearable
                        v-model="item.receiveAddress" maxlength="50"></el-input>
            </div>
          </div>
        </div>


      </div>
    </div>
    <div class="row-me row-center flex-end1 margin-top30">
      <div class="btn-blue width120 line-height40" @click="clickSendOk">确认发货</div>
    </div>
  </div>
</template>

<script>
import cityData from '../../assets/js/citys.js'

export default {
  components: {},
  props: {
    orderArray: {
      type: Array,
      default: () => [],
    },
    source: {//页面来源，普通订单：normal，联单：link
      type: String,
      default: '',
    }
  },
  data() {
    return {
      showOrderArray: [],
      provinceArray: [],
      cityArray: [],
      areaArray: [],
      deliveryTypeArray: [{id: 0, name: '寄付现结'}, {id: 1, name: '到付'}, {id: 2, name: '寄付月结'}],
      isSaving: false,
      isOpenExpress: false,//是否开通了顺丰快递
    }
  },
  // 侦听器
  watch: {},
  // 计算属性
  computed: {},
  // html加载完成之前
  created() {
    this.provinceArray = cityData
    for (let item of this.orderArray) {
      item.sendType = '标快'
      item.sendMethod = '上门取件'
      item.isInsure = false
      item.orderId = item.id
      item.deliveryType = 2
      item.type = this.source === 'link' ? 2 : 1//1其他发货，2联单发货
    }
    this.showOrderArray = this.orderArray
    this.getMonthNo()
  },
  // html加载完成后执行。
  mounted() {

  },
  // 事件方法执行
  methods: {
    provinceChange(e, item) {
      item.receiveCity = ''
      item.receiveRegion = ''
      this.cityArray = []
      this.areaArray = []
      if (e && e !== '') {
        for (let i = 0; i < this.provinceArray.length; i++) {
          let item = this.provinceArray[i]
          if (e === item.n) {
            this.cityArray = item.c
          }
        }
      }
    },
    cityChange(e, item) {
      item.receiveRegion = ''
      this.areaArray = []
      if (e && e !== '') {
        for (let i = 0; i < this.cityArray.length; i++) {
          let item = this.cityArray[i]
          if (e === item.n) {
            this.areaArray = item.c
          }
        }
      }
    },
    //运费方式改变
    deliveryTypeChange(e, item) {
      let arr = this.deliveryTypeArray.filter(item => {
        return item.id === e
      })
      if (arr.length > 0 && arr[0].name.indexOf('月结') === -1) {
        item.monthCard = ''
      } else {
        this.getMonthNo()
      }
    },
    //确认发货
    clickSendOk() {
      if (this.isSaving) return;
      let title = this.source === 'normal' ? '处方' : this.source === 'link' ? '联单' : ''
      for (let i = 0; i < this.showOrderArray.length; i++) {
        let item = this.showOrderArray[i]
        if (item.deliveryCompany === '厂内配送' || item.deliveryCompany === '自提') {
          if (this.$method.isEmpty(item.deliveryStaff)) {
            this.$message.error(title + (i + 1) + '的配送人员不能为空')
            return
          }
          if (this.$method.isEmpty(item.freightFee)) {
            this.$message.error(title + (i + 1) + '的运费金额不能为空')
            return
          }
        } else {
          if (this.$method.isEmpty(item.deliveryNo) && !this.isOpenExpress) {
            this.$message.error(title + (i + 1) + '的快递单号不能为空')
            return
          }
          if (this.$method.isEmpty(item.sendType)) {
            this.$message.error(title + (i + 1) + '的寄件类型不能为空')
            return
          }
          if (this.$method.isEmpty(item.deliveryType)) {
            this.$message.error(title + (i + 1) + '的运费方式不能为空')
            return
          }
          if (item.deliveryType === 2 && this.$method.isEmpty(item.monthCard)) {
            this.$message.error(title + (i + 1) + '的月结卡号不能为空')
            return
          }
          if (item.deliveryType !== 1 && this.$method.isEmpty(item.freightFee)) {
            this.$message.error(title + (i + 1) + '的运费金额不能为空')
            return
          }
        }
        if (this.$method.isEmpty(item.receiveName) || this.$method.isEmpty(item.receiveMobile)
            || this.$method.isEmpty(item.receiveProvince) || this.$method.isEmpty(item.receiveCity)
            || this.$method.isEmpty(item.receiveRegion) || this.$method.isEmpty(item.receiveAddress)) {
          this.$message.error(title + (i + 1) + '的收件人信息请填写完整')
          return
        }
        //清空不是寄付月结的月结单号
        if (item.deliveryType !== 2) {
          item.monthCard = ''
        }
      }
      this.isSaving = true
      this.$postRequest('/admin/order/fahuoFinish', this.showOrderArray).then((res) => {
        if (res) {
          this.$message.success(res.message)
          this.$emit('sendSuccess')
        }
        this.isSaving = false
      }).catch((error) => {
        console.log(error)
        this.isSaving = false
      })
    },
    //获取月结号
    getMonthNo() {
      this.$getRequest('/admin/sfExpress/getExpress', {}).then((res) => {
        if (res) {
          this.isOpenExpress = res.data.isOpenExpress
          for (let item of this.showOrderArray) {
            item.monthCard = res.data.monthCard
          }
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.sendDialog {
  height: 80vh;
  padding: 0 50px;

  .item-order {
    margin-bottom: 20px;
    padding: 20px;
    border: 2px solid #e7e7e7;
    border-radius: 10px;

    .left-title {
      width: 110px;
      text-align: right;
    }
  }
}
</style>
